import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { WalkinWaitlistToggleRequest } = protos;

export function toggleOnlineWalkinWaitlist(isOn: boolean) {
  const request = WalkinWaitlistToggleRequest.fromObject({
    isOn: isOn,
  });

  return {
    TockApi: {
      putProto: `/walkin-waitlist/toggle`,
      type: AppConstants.ONLINE_WALKIN_WAITLIST_TOGGLE,
      request,
    },
  };
}
